module.exports = __webpack_public_path__ + "img/09.769f5788.png";